import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../../css_variables';
import {injectIntl} from 'react-intl';
import HoursInput from '../hours-input/hours_input_view';
import SuggestedTimeRenderer from './suggested_time_renderer';
import {subscribe, unsubscribe, EVENT_ID} from '../../../../../containers/event_manager';

export const InputStyle = styled.div`
	color: ${CSS_CONSTANTS.v2_text_gray};
	font-size: 13px;

	.input-suggestions {
		display: flex;
		align-items: flex-end;
		.title-input-wrapper {
			display: flex;
			flex-direction: column;
			.ai-icon {
				margin-right: 8px;
				opacity: 0.39;
			}
			&.hour-input {
				width: 90px;
			}
			.icon-title-wrapper {
				display: flex;
				flex-direction: row;
				min-height: 16px;
				font-weight: 500;
				.information-icon {
					height: 11px;
					width: 11px;
					margin-left: 4px;
					margin-bottom: 4px;
					cursor: help;
				}
			}
			.input-title {
				color: ${CSS_CONSTANTS.v2_text_light_gray};
				font-size: 9px;
				text-transform: uppercase;
				margin-bottom: 5px;
				letter-spacing: 1px;
			}
		}
	}
`;

const TimeRegWSuggestionsInput = ({id, onInputChange, onChildComponentBlur, initialValue, date, task, idleTime, innerRef, parentKeyDown, focusOnMount, clearable, viewer, infoText, intl: {formatMessage}, userpilot, disabled, changeOnlyOnValid}) => {
	const [inputValue, setInputValue] = useState(initialValue);

	const handleInputChange = value => {
		if (inputValue !== value) {
			setInputValue(value);
			if (onInputChange) onInputChange(value);
		}
	};

	const handleSuggestionClick = (x, value, y) => {
		handleInputChange(value);
	};

	const onInputBlur = (value, e) => {
		setInputValue(value);
		if (onInputChange) onInputChange(value);
		if (onChildComponentBlur) onChildComponentBlur(e);
	};

	useEffect(() => {
		const handleInputClear = () => {
			handleInputChange('');
		};
		if (clearable) {
			subscribe(EVENT_ID.RESET_INPUT, handleInputClear);
		}
		return () => {
			if (clearable) {
				unsubscribe(EVENT_ID.RESET_INPUT, handleInputClear);
			}
		};
	}, [inputValue]);

	return (
		<InputStyle>
			<div className="input-suggestions">
				<div className="title-input-wrapper hour-input">
					<div className="icon-title-wrapper">
						<div className="input-title">{formatMessage({id: 'common.time_entry'})}</div>
					</div>
					<HoursInput
						customClassName={'hour-input'}
						placeholder={formatMessage({id: 'hours_input.placeholder'})}
						cy={'new-time-entry-input'}
						id={id}
						value={inputValue}
						mutation={onInputBlur}
						focusOnMount={focusOnMount}
						innerRef={innerRef}
						minuteLimit={1440}
						mutationValidChange={changeOnlyOnValid}
						parentKeyDown={parentKeyDown}
						userpilot={userpilot}
						disabled={disabled}
						infoText={infoText}
					/>
				</div>
				{date && (task || idleTime) && !disabled ? (
					<div className="title-input-wrapper">
						<SuggestedTimeRenderer
							addTimeSuggestion={handleSuggestionClick}
							inputParent={task ? {task} : idleTime ? {idleTime} : null}
							timeSuggestionsEnabled={true}
							date={date}
							personId={viewer.actualPersonId}
							dateString={date.format('YYYY-MM-DD')}
							usePopup={false}
							selectedValue={inputValue}
							onOptionBlur={onChildComponentBlur}
						/>
					</div>
				) : null}
			</div>
		</InputStyle>
	);
};

TimeRegWSuggestionsInput.defaultProps = {
	changeOnlyOnValid: true,
};
export default injectIntl(TimeRegWSuggestionsInput);
